export const centsToDollars = (cents: number): number => {
  return cents / 100
}

export const dollarsToCents = (dollars: number): number => {
  return Math.round(dollars * 100)
}
